<template>
    <div class="main">
        <el-card class="box-card" style="width: 500px;margin: 15px 20px; ">
            <div slot="header" class="clearfix">
                <span>添加预设</span>
            </div>

            <div class="main-border">
              <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                  <el-form-item label="管理员id" prop="admin_id">
                      <el-input v-model.trim="form.admin_id" size="small" placeholder="请输入管理员id"/>
                  </el-form-item>
                  <el-form-item label="微信头像" prop="head_img">
                      <el-upload
                          ref="upload"

                          :file-list="fileList"
                          action="#"
                          accept="image/jpg, image/jpeg ,image/png"
                          :limit="1"
                          :multiple="false"
                          list-type="picture"
                          :auto-upload="false"
                          :on-remove="handleRemove"
                          :on-change="handleChange">
                          <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                  </el-form-item>
                  <div  style="margin-left: 40px;width: 300px;margin-bottom: 30px;color: #888888">只能上传jpg/jpeg/png文件，且不超过2MB</div>
                  <el-form-item label="微信昵称" prop="nick_name">
                      <el-input v-model.trim="form.nick_name" size="small" placeholder="请输入昵称"/>
                  </el-form-item>
                  <el-form-item label="预设奖品" prop="prize_name">
                      <el-select v-model="form.preset_prize" ref="selection" placeholder="请选择奖品" size="small">
                          <el-option
                              v-for="item in presetPrize"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="onSubmit('form')" :loading="loading">提交</el-button>
                  </el-form-item>
              </el-form>
            </div>

        </el-card>
        <el-card  style="width: 500px;margin: 15px 20px;">
            <div slot="header" class="clearfix">
                <span>兑换码录入</span>
            </div>
            <div style="display: flex;flex-direction: column">

                <div style="margin-bottom: 20px;color: #666666">
                    <span>888数量 <span style="font-size: 30px;margin-left: 15px;font-weight: bold;color: #e55825">{{code888Num}}</span></span>
                    <span style="margin-left: 20px;">88数量 <span style="font-size: 30px;margin-left: 15px;font-weight: bold;color: #e55825">{{code88Num}}</span></span>
                    <span style="margin-left: 20px;">200坐骑数量 <span style="font-size: 30px;margin-left: 15px;font-weight: bold;color: #e55825">{{code200Num}}</span></span>
                </div>

                <el-form>
                    <el-form-item label="兑换码" prop="prize_name">
                        <el-input
                                type="textarea"
                                :rows="8"
                                placeholder="请输入兑换码，多个请换行"
                                style="width: 400px;"
                                v-model="inputCode">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="对应礼包" prop="prize_name">
                        <el-select v-model="awardId"  ref="selection" placeholder="请选择奖品" size="small">
                            <el-option label="价值888元游戏礼包" value="36"></el-option>
                            <el-option label="价值88元游戏礼包" value="37"></el-option>
                            <el-option label="价值200元坐骑礼包" value="38"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button type="primary"  @click="submitCode" :loading="inputCodeLoading" style="margin-top: 30px;width: 200px;">确认添加兑换码</el-button>
            </div>
        </el-card>



    </div>
</template>

<script>
let fd = new FormData();
import {uploadPreset, htglAddCode, getHtglCodeNum} from "@/api/request";
export default {
    name: "registerDrawAdd",
    data(){
        return {
            loading: false,
            presetPrize: [
                {value: '36',label: '价值888元游戏礼包'},
                {value: '37',label: '价值88元游戏礼包'},
                {value: '38',label: '价值200元坐骑礼包'},
                {value: '39',label: '188元现金红包'},
                {value: '40',label: '8元现金红包'},
                {value: '41',label: '2元现金红包'},
                {value: '42',label: '30元平台币'},
                {value: '43',label: '25元平台币'},
                {value: '44',label: '8元平台币'},
            ],
            form:{
                admin_id: '',
                head_img: '',
                nick_name: '',
                preset_prize: ''
            },
            fileList: [],
            rules: {
                admin_id: [{ required: true, message: '请输入管理员id', trigger: 'blur' }],
                head_img: [
                    { required: true, message: '请添加头像', trigger: 'blur' },
                ],
                nick_name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
                preset_prize: [{ required: true, message: '请选择奖品', trigger: 'blur' }],
            },
            inputCode: '',
            awardId: '',
            inputCodeLoading: false,
            code888Num: '-',
            code88Num: '-',
            code200Num: '-',
        }
    },
    mounted() {
        this.getCodeNum();
    },
    methods:{
        onSubmit(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    const isLt2M = this.form.head_img.size / 1024 / 1024 < 2;
                    if (!isLt2M) {
                        this.$message.error('上传头像图片大小不能超过 2MB!');
                        return false;
                    }
                    fd.append("adminId",this.form.admin_id)
                    fd.append("nickName",this.form.nick_name)
                    fd.append("presetPrize",this.form.preset_prize)
                    uploadPreset(fd).then(res => {
                        if (res.data.success) {
                            this.loading = false;
                            this.$message.success("添加成功")
                        }else {
                            this.$message.error(res.data.error.message);
                            this.loading = false;
                        }
                    }).finally(() => {
                        fd = new FormData();
                        this.form = {
                            admin_id: '',
                            head_img: '',
                            nick_name: '',
                            preset_prize: ''
                        }
                        this.handleRemove();
                    })
                } else {
                    return false;
                }
            });
        },
        submitCode() {
            if (!this.inputCode) {
                this.$message.error('请输入兑换码');
                return ;
            }
            if (!this.awardId) {
                this.$message.error('请选择兑换码对应的奖品');
                return ;
            }
            console.log(this.inputCode)
            this.inputCodeLoading = true;
            let params = {
                code: this.inputCode,
                awardId: this.awardId
            }
            htglAddCode(params).then(res => {
                this.inputCodeLoading = false;
                if (res.data.success) {
                    this.getCodeNum();
                    this.$message.success(res.data.data);
                    this.inputCode = '';
                    this.awardId = '';
                }
                else {
                    this.$message.error(res.data.error.message);
                }
            });
        },
        getCodeNum() {
            getHtglCodeNum().then(res => {
                if (res.data.success) {
                    this.code888Num = res.data.data.code888Num;
                    this.code88Num = res.data.data.code88Num;
                    this.code200Num = res.data.data.code200Num;
                }
                else {
                    //this.$message.error(res.data.error.message);
                }
            });
        },
        handleRemove(file, fileList){
            if(this.fileList != null){
                this.fileList.shift();
            }
        },
        handleChange(file, fileList){
            fd.append("file",file.raw)
            this.form.head_img = file.raw;
            this.fileList.push({name: file.name,url:file.url})
        }
    }   
}
</script>

<style scoped>
    .main {
        display: flex;
    }

    .main-border{
        width: 40%;
    }
    /deep/ .el-input {
        width: 250px !important;
        min-width: 200px;
    }

    /deep/ .el-input__inner {
        border-radius: 2px !important;
        border: 1px solid #aaaaac !important;
    }

    /deep/ .el-form-item__label {
        font-weight: 600;
        font-size: 13px;
    }
</style>